import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import Button from 'sushiweb/Button';
import Modal from 'sushiweb/Modal';
import PropTypes from 'prop-types';
import _get from 'lodash-es/get';
import _noop from 'lodash-es/noop';
import Layout from 'sushiweb/Layout';
import H6 from 'sushiweb/Typography/Heading/H6';
import { P } from 'sushiweb/Typography/Text';
// import Upload from 'sushiweb/Icons/all/Upload';
import Download from 'sushiweb/Icons/all/Download';
import ChipsWrapper from 'sushiweb/InputTypes/Chips';
import CheckCircleFill from 'sushiweb/Icons/all/CheckCircleFill';
import green from 'sushiweb/tokens/color/green';
import H5 from 'sushiweb/Typography/Heading/H5';
import TimeFill from 'sushiweb/Icons/all/TimeFill';
import orange from 'sushiweb/tokens/color/orange';

import { validateEmail } from '../../../../utility';
import {
  ButtonWrapper,
  ClearFileUploadCrossWrapper,
  CreateButtonWrapper,
  CreateGroupModalFooter,
  CreateTeamHelperText,
  InputWrapper,
  ModalFieldsWrapper,
  ModalSuccessWrapper,
  StyledInput,
  TextWrapper,
  UnsuccessfulDownloadBtn,
  UnsuccessfulDownloadText,
  UnsuccessfulUploadText,
  UploadFileWrapper,
  UploadIconWhite,
  UploadSectionContainer,
  clearFileBtnStyle,
  chipsStyle,
  disabledUploadBtnStyle,
  downloadBtnStyle,
  uploadBtnStyle,
  uploadFileText,
  ChipsConatiner,
} from './styles';
import {
  checkFileTypeSize,
  clearInputValue,
  downloadGroupCSV,
} from '../../../../helpers';
import {
  DASHBOARD,
  applicableFlowTypes,
  currentFlowTypeEnum,
  genericErrorMsg,
  groupUploadErrMsg,
  groupUploadMsg,
  uploadErrorStatus,
  uploadSuccessStatus,
  wrongFormat,
} from '../constants';
import usePolling from '../../utils/usePolling';
import { UPLOAD_GROUP_URL } from '../../../../constants/urls';
import { ConfirmUpload, UploadsContainer } from '../../styles';
import { EMPLOYEES_ROUTE } from '../../../../constants/routes';
import {
  ClearFileUploadCross,
  FileSVG,
  SingleLineArrow,
} from '../../../../components/SVGs/commonSVGs';

const CreateGroupModal = ({
  currentFlow,
  currentTab,
  clearCreateGroup,
  selectedWorkspace,
  showErrorToast,
  isVisible,
  closeModal,
  heading,
  processId,
  createGroup,
  creatingGroup,
  groupCreated,
  setFileUploadMsg,
  uploadMsg,
  groupEmployees,
  isAddEmployeeToGroup,
}) => {
  const [name, setName] = useState('');
  const [emailList, setEmailList] = useState([]);
  const [file, setFile] = useState(null);
  const [inputDisabled, setInputDisabled] = useState(false);
  const [uploadStatus, setUploadStatus] = useState('');
  const [uploadData, setUploadData] = useState([]);
  const [isPollingStarted, setIsPollingStarted] = useState(false);
  const [pollingFrequency, setPollingFrequency] = useState(2);
  const url = UPLOAD_GROUP_URL;
  const showProgressBar = uploadStatus === '' || uploadStatus === 'completed';
  let successful = '';
  let unsuccessful = '';
  let unsuccessfulLink = '';

  const updateName = val => {
    if (val.length <= 50) {
      setName(val);
    }
  };

  const handleClearFileClick = () => {
    setFile(null);
  };

  const addEmailList = val => {
    if (validateEmail(val)) {
      setEmailList([...emailList, val]);
    }
  };

  const removeEmailList = val => {
    const updatedEmailList = [...emailList];
    updatedEmailList.splice(val, 1);
    setEmailList(updatedEmailList);
  };

  const emailCheck = val => {
    return validateEmail(val);
  };

  useEffect(() => {
    if (groupCreated) {
      setIsPollingStarted(true);
      setInputDisabled(true);
    }
  }, [groupCreated]);

  useEffect(() => {
    if (uploadStatus === 'completed') {
      setIsPollingStarted(false);
      clearCreateGroup();
    } else if (uploadStatus === 'failed') {
      clearCreateGroup();
    }
  }, [uploadStatus]);

  const TopScroll = () => {
    const successRef = useRef();
    useEffect(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
    return <div ref={successRef} />;
  };

  const onResponse = ({ isError, response }) => {
    let message = '';
    const status = _get(response, 'data.status', '');
    const uploads = _get(response, 'data.uploads', []);
    setUploadStatus(status);
    setUploadData(uploads);
    if (uploadSuccessStatus.includes(status)) {
      message = _get(response, 'data.message.title', groupUploadMsg);
    } else {
      message = _get(response, 'data.message.title', genericErrorMsg);
    }
    setFileUploadMsg(message);
    if (isError) {
      setIsPollingStarted(false);
      setFileUploadMsg(groupUploadErrMsg);
      setUploadStatus('failed');
      return;
    }
    if (uploadSuccessStatus.includes(status) && !isError) {
      setPollingFrequency(3);
    } else {
      setIsPollingStarted(false);
    }
  };

  usePolling({
    processId,
    frequency: pollingFrequency,
    isPollingStarted,
    onResponse,
    url,
  });

  const onChange = e => {
    checkFileTypeSize(e.target.files[0])
      .then(success => {
        if (success) {
          setFile(e.target.files[0]);
        } else {
          showErrorToast(wrongFormat);
          clearInputValue();
        }
      })
      .catch(err => {
        clearInputValue();
        showErrorToast();
        console.log(err);
      });
  };

  const appendHeaderAndconvertArrayToCSV = emails => {
    const FinalEmails = ['emailid', ...emails];
    const csvContent = FinalEmails.map(row => `"${row}"`).join('\n');
    return csvContent;
  };

  const goNextForEmailChips = () => {
    const csvData = appendHeaderAndconvertArrayToCSV(emailList);
    const blob = new Blob([csvData], { type: 'text/csv' });
    const fileBody = new FormData();
    if (isAddEmployeeToGroup) {
      fileBody.append('group_id', groupEmployees.group_id);
      fileBody.append('file', blob);
    } else {
      fileBody.append('name', name);
      fileBody.append('file', blob);
    }
    createGroup({
      fileBody,
      workspaceId: selectedWorkspace.workspace_id ?? '',
      flowType: currentFlow,
    });
  };

  const goNext = () => {
    const fileBody = new FormData();
    if (isAddEmployeeToGroup) {
      fileBody.append('group_id', groupEmployees.group_id);
      fileBody.append('file', file);
    } else {
      fileBody.append('name', name);
      fileBody.append('file', file);
    }
    createGroup({
      fileBody,
      workspaceId: selectedWorkspace.workspace_id ?? '',
      flowType: currentFlow,
    });
  };

  const disabled =
    !!(name || groupEmployees.group_name) &&
    (file !== null || emailList.length !== 0);

  const fileUploadDisabled = inputDisabled || emailList.length !== 0;
  const emailListDisabled = inputDisabled || file;

  const rendorEmployeeUpdateModal = () => {
    return (
      <ModalFieldsWrapper>
        <ConfirmUpload
          status={uploadStatus}
          progress={isPollingStarted}
          show={!showProgressBar || isPollingStarted || creatingGroup}
        >
          {uploadMsg}
        </ConfirmUpload>
        {!['failed', 'completed', 'terminated'].includes(uploadStatus) && (
          <UploadSectionContainer>
            <Layout>
              <Layout.Item colD={12} colT={12} colM={12}>
                <InputWrapper>
                  <StyledInput
                    innerWidth='100%'
                    label='Enter team name'
                    value={
                      isAddEmployeeToGroup ? groupEmployees.group_name : name
                    }
                    onChange={updateName}
                    type='text'
                    disabled={inputDisabled || isAddEmployeeToGroup}
                  />
                  <CreateTeamHelperText>
                    {' '}
                    Eg- Sales_GGN, Human Resources, All{' '}
                  </CreateTeamHelperText>
                </InputWrapper>
              </Layout.Item>
            </Layout>
            <UploadFileWrapper>
              <Layout>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <ChipsConatiner>
                    <ChipsWrapper
                      activeColors={chipsStyle}
                      inertColors={chipsStyle}
                      label='Add employee email ID(s)'
                      useBackSpace
                      list={emailList}
                      onAdd={addEmailList}
                      onRemove={removeEmailList}
                      helperText='Use comma or space to add multiple email IDs'
                      errorText='Please enter valid email ID'
                      validator={emailCheck}
                      disabled={emailListDisabled}
                    />
                  </ChipsConatiner>
                </Layout.Item>
                <Layout.Item colD={6} colT={6} colM={6}>
                  {' '}
                </Layout.Item>
                <Layout.Item colD={6} colT={6} colM={6}>
                  <H6>OR</H6>
                </Layout.Item>
                <Layout.Item colD={12} colT={12} colM={12}>
                  <ButtonWrapper>
                    <label
                      htmlFor='upload-file'
                      style={
                        fileUploadDisabled || file
                          ? disabledUploadBtnStyle
                          : uploadBtnStyle
                      }
                    >
                      <input
                        style={{
                          display: 'inline-block',
                          width: '100%',
                          padding: '120px 0 0 0',
                          height: '100px',
                          overflow: 'hidden',
                          zIndex: 2,
                          cursor:
                            !fileUploadDisabled && !file
                              ? 'pointer'
                              : 'default',
                        }}
                        id='upload-file'
                        type='file'
                        accept='.csv'
                        onChange={onChange}
                        disabled={fileUploadDisabled || file}
                      />
                      <H6
                        style={
                          fileUploadDisabled || file
                            ? {
                                color: '#9197A6',
                                cursor: 'default',
                                ...uploadFileText,
                              }
                            : {
                                color: '#EF4F5F',
                                cursor: 'pointer',
                                ...uploadFileText,
                              }
                        }
                      >
                        Upload employee list
                      </H6>
                    </label>
                  </ButtonWrapper>
                </Layout.Item>
                <Layout.Item colD={7.5} colT={7.5} colM={7.5}>
                  <TextWrapper>
                    {file != null && (
                      <div>
                        <P> 1 File selected </P>
                        <ClearFileUploadCrossWrapper>
                          <FileSVG />
                          <H6 style={{ paddingLeft: '5px', marginTop: '-8px' }}>
                            {' '}
                            {file.name}
                          </H6>
                          <Button
                            appearance='outline'
                            style={clearFileBtnStyle}
                            onClick={handleClearFileClick}
                            icon={<ClearFileUploadCross />}
                          />
                        </ClearFileUploadCrossWrapper>
                      </div>
                    )}
                    <P> &#x2022; Only .csv files supported</P>
                    <P> &#x2022; File size upto 5MB</P>
                    <P>
                      {' '}
                      &#x2022; Only registered domain email IDs will be accepted
                    </P>
                  </TextWrapper>
                </Layout.Item>
                <Layout.Item colD={3.4} colT={7.5} colM={7.5}>
                  <Button
                    appearance='outline'
                    style={downloadBtnStyle}
                    onClick={downloadGroupCSV}
                    icon={<Download />}
                    btnColor='coal'
                    iconAlign='left'
                  >
                    Download sample file
                  </Button>
                </Layout.Item>
              </Layout>
            </UploadFileWrapper>

            <CreateButtonWrapper>
              <Button
                onClick={file != null ? goNext : goNextForEmailChips}
                loading={creatingGroup || isPollingStarted}
                disabled={!disabled}
                icon={<SingleLineArrow />}
                iconAlign='right'
              >
                Next
              </Button>
            </CreateButtonWrapper>
          </UploadSectionContainer>
        )}
        {(!showProgressBar || isPollingStarted || creatingGroup) && (
          <TopScroll />
        )}
        {uploadErrorStatus.includes(uploadStatus) && !isPollingStarted && (
          <UploadsContainer>
            <ModalSuccessWrapper>
              <TimeFill color={orange.z500} size='7rem' />;
              <H5>Team Creation Failed</H5>
              <P>Add upto 5000 employees in one file</P>
              <Button
                appearance='outline'
                btnColor='red'
                style={{ marginBottom: '15px' }}
                onClick={goNext}
                loading={creatingGroup}
                disabled={!disabled}
              >
                Try Again
              </Button>
            </ModalSuccessWrapper>
          </UploadsContainer>
        )}
        {uploadStatus === 'completed' && !isPollingStarted && (
          <UploadsContainer>
            {uploadData.forEach(uploadInfo => {
              const { title = '', subtitle = '', link = '' } = uploadInfo;
              if (title === 'Successful Uploads')
                successful = subtitle.split(' ');
              else if (title === 'Unsuccessful Uploads') {
                unsuccessful = subtitle.split(' ');
              }
              if (unsuccessful[0] !== '0') {
                unsuccessfulLink = link;
              }
            })}
            <ModalSuccessWrapper>
              <CheckCircleFill color={green.z500} size='7rem' />;
              <H5>
                {isAddEmployeeToGroup
                  ? 'Employees added successfully'
                  : 'Team created successfully'}
              </H5>
              {unsuccessful[0] !== '0' ? (
                <P>
                  {successful[0]}{' '}
                  {successful[0] === '0' || successful[0] === '1'
                    ? 'employee'
                    : 'employees'}{' '}
                  added
                </P>
              ) : (
                <P>View your teams in the ‘Employees’ section</P>
              )}
              {currentTab === DASHBOARD ? (
                <Link to={EMPLOYEES_ROUTE}>
                  <Button
                    style={{ marginBottom: '15px' }}
                    appearance='outline'
                    btnColor='red'
                  >
                    Go to ‘Employees’ section
                  </Button>
                </Link>
              ) : (
                <Button
                  style={{ marginBottom: '15px' }}
                  btnColor='red'
                  onClick={closeModal}
                >
                  Done
                </Button>
              )}
              {unsuccessful[0] !== '0' ? (
                <CreateGroupModalFooter>
                  <UnsuccessfulUploadText>
                    <H5>
                      {unsuccessful[0]}{' '}
                      {unsuccessful[0] === '0' || unsuccessful[0] === '1'
                        ? 'employee'
                        : 'employees'}{' '}
                      could not be added
                    </H5>
                    <P>Download file to see why </P>
                  </UnsuccessfulUploadText>
                  <UnsuccessfulDownloadText
                    href={unsuccessfulLink}
                    target='_blank'
                    rel='noreferrer'
                  >
                    <UnsuccessfulDownloadBtn>
                      Download
                      <UploadIconWhite>
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          width='16'
                          height='16'
                          viewBox='0 0 16 16'
                          fill='none'
                        >
                          <path
                            d='M2 12.6654H14V13.9987H2V12.6654ZM8.66667 8.77977L12.7141 4.73236L13.6569 5.67518L8 11.332L2.34315 5.67518L3.28595 4.73236L7.33333 8.77977V1.33203H8.66667V8.77977Z'
                            fill='#414A5D'
                          />
                        </svg>
                      </UploadIconWhite>
                    </UnsuccessfulDownloadBtn>
                  </UnsuccessfulDownloadText>
                </CreateGroupModalFooter>
              ) : null}
            </ModalSuccessWrapper>
          </UploadsContainer>
        )}
      </ModalFieldsWrapper>
    );
  };

  return (
    <>
      <Modal
        isCentered
        visible={isVisible}
        onClose={closeModal}
        showCloseIcon
        title={heading}
      >
        {rendorEmployeeUpdateModal()}
      </Modal>
    </>
  );
};

CreateGroupModal.propTypes = {
  currentFlow: PropTypes.oneOf(applicableFlowTypes),
  currentTab: PropTypes.string,
  clearCreateGroup: PropTypes.func,
  selectedWorkspace: PropTypes.objectOf(PropTypes.any),
  isVisible: PropTypes.bool,
  closeModal: PropTypes.func,
  heading: PropTypes.string,
  showErrorToast: PropTypes.func,
  processId: PropTypes.string,
  createGroup: PropTypes.func,
  creatingGroup: PropTypes.bool,
  groupCreated: PropTypes.bool,
  setFileUploadMsg: PropTypes.func,
  uploadMsg: PropTypes.string,
  groupEmployees: PropTypes.objectOf(PropTypes.any),
  isAddEmployeeToGroup: PropTypes.bool,
};

CreateGroupModal.defaultProps = {
  currentFlow: currentFlowTypeEnum.FLOW_TYPE_PPI,
  currentTab: '',
  clearCreateGroup: _noop,
  selectedWorkspace: {},
  isVisible: true,
  closeModal: _noop,
  heading: '',
  processId: '',
  uploadMsg: '',
  createGroup: _noop,
  creatingGroup: false,
  groupCreated: false,
  showErrorToast: _noop,
  setFileUploadMsg: _noop,
  groupEmployees: {},
  isAddEmployeeToGroup: false,
};

export default CreateGroupModal;
